import { track as mixpanelTrack } from '@utils/mixpanel'

const onToggle = (setCurrLang, user) => {
  if (typeof Localize !== 'undefined') {
    const locale = Localize?.getLanguage()
    if (!locale || locale === 'es-MX') {
      Localize.setLanguage('en')
      setCurrLang('Spanish')
    } else {
      Localize.setLanguage('es-MX')
      setCurrLang('English')
    }

    mixpanelTrack('set_site_language', {
      action: 'language_toggle',
      user: user?.email,
      email: user?.email,
      toggled_to: Localize.getLanguage() === 'en' ? 'English' : 'Spanish',
    })
  }

  return false
}

export default onToggle
